import React from 'react';

let ErrorBanner = (props) => {
    return (
           <h1 className='back__title'>Error</h1>
    )
}

export default ErrorBanner;